// extracted by mini-css-extract-plugin
module.exports = {"no-results-text":"NoResults_no-results-text__yqMoJ"};